/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Kantor_S3Inputs */

const en_tut_kantor_s3 = /** @type {(inputs: Tut_Kantor_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To move: click the floor you want, or focus the map and use the arrow keys or WASD. The **Ruang & area** panel also has **Pindah ke ruang**.`)
};

const id_tut_kantor_s3 = /** @type {(inputs: Tut_Kantor_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Berpindah: klik lantai tujuan, atau fokuskan peta lalu pakai tombol panah / WASD. Panel **Ruang & area** juga punya **Pindah ke ruang**.`)
};

/**
* | output |
* | --- |
* | "To move: click the floor you want, or focus the map and use the arrow keys or WASD. The **Ruang & area** panel also has **Pindah ke ruang**." |
*
* @param {Tut_Kantor_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_kantor_s3 = /** @type {((inputs?: Tut_Kantor_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Kantor_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_kantor_s3(inputs)
	return en_tut_kantor_s3(inputs)
});